import actions from './actions'
import mutations from './mutation'

const state = {
  //当前订阅区块链的chainCid
  chainCid: '',
  //订阅区块链列表
  subscribe_list: [],
  subscribe_paging: {
    offset: 0,
    limit: 10,
    total: 0
  },
  //区块
  block_list: [],
  block_paging: {
    offset: 0,
    limit: 10,
    total: 0
  },
  //合约
  contract_list: [],
  contract_paging: {
    offset: 0,
    limit: 10,
    total: 0
  },
  //交易
  txn_list: [],
  txn_paging: {
    offset: 0,
    limit: 10,
    total: 0
  },
  // 加载状态
  homeLoading: false
}

export default {
  state,
  actions,
  mutations
}
